var map = {
	"./awaiting_delivery-icon.svg": 6541,
	"./awaiting_store_confirmation-icon.svg": 76876,
	"./canceled-icon.svg": 75955,
	"./closed-icon.svg": 67688,
	"./delivered-icon.svg": 11792,
	"./in_return-icon.svg": 67532,
	"./in_return_courier-icon.svg": 49645,
	"./in_source_preparation-icon.svg": 11229,
	"./in_transit-icon.svg": 17601,
	"./pending_package-icon.svg": 33211,
	"./pickup-icon.svg": 1656,
	"./ready_for_pickup-icon.svg": 55151,
	"./rescheduled-icon.svg": 14761,
	"./return_in_review-icon.svg": 95740,
	"./returned-icon.svg": 37710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42791;